<template>
  <div>
    <el-dialog :title="dataForm.id ? 'Edit Tag' : 'Add Tag'" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">
      <el-form :model="dataForm" :rules="dataRule" ref="formRef" label-width="100px">
        <el-form-item label="Tag Name" prop="tagName">
          <el-input v-model="dataForm.tagName" clearable></el-input>
        </el-form-item>
        <el-form-item label="Remark" prop="remark">
          <el-input v-model="dataForm.remark" type="textarea" :rows="5" :autosize="{ minRows: 4 }" resize="none" placeholder="Remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        id: "",
        tagName: "",
        remark: "",
      },
      dataRule: {
        tagName: [{ required: true, message: "please enter", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.dialogVisible = true;
      await this.$nextTick();
      this.$refs.formRef.resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          tagName: data.tagName,
          remark: data.remark || "",
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      if (params.id) {
        return this.$http.post(`/admin/clientTagInfo/${params.id}/update`, params);
      } else {
        return this.$http.post("/admin/clientTagInfo/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.$emit("update");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
